import { useMemo } from "react";
import { useIdentificationDocumentRemindersListQuery } from "web_myplann/Api/Reminders/useIdentificationDocumentRemindersListQuery";
import { useReminderTypesQuery } from "web_myplann/Api/Reminders/useReminderTypesQuery";
import { RemindersSectionView } from "web_myplann/Reminders/Components/RemindersSectionView";
import { getReminderEntityConfig } from "web_myplann/Reminders/Config/reminderEntityConfig";
import type { ReminderEntity } from "web_myplann/Reminders/Types/ReminderTypes";
import { hasSelectableTemplates } from "web_myplann/Reminders/Utils/hasSelectableTemplates";

type Props = {
	entity: ReminderEntity;
};

export const IdentificationDocumentRemindersSectionContent = ({
	entity,
}: Props) => {
	const { data, isLoading, isError } =
		useIdentificationDocumentRemindersListQuery(entity.id);
	const { data: templates } = useReminderTypesQuery(entity);

	const canAdd = useMemo(() => {
		if (!templates) {
			return true;
		}
		return hasSelectableTemplates(
			templates,
			getReminderEntityConfig(entity.type),
			entity.validTo,
		);
	}, [templates, entity.type, entity.validTo]);

	return (
		<RemindersSectionView
			entity={entity}
			reminders={data}
			isLoading={isLoading}
			isError={isError}
			canAdd={canAdd}
		/>
	);
};
